export enum StripePaymentStatus {
  SUCCEEDED = "succeeded", // payment was done successfully
  REQUIRES_CAPTURE = "requires_capture", // hold was marked successfully
  FAILED = "failed" // payment was not successful and redirect was done
}

export const STRIPE_PAYMENT_SUCCESS_LIST = [StripePaymentStatus.SUCCEEDED, StripePaymentStatus.REQUIRES_CAPTURE];
